import styled from 'styled-components';
import { theme } from '../../../global';

type TCaseContainerProps = {
    $isWide?: boolean
}

export const CaseContainer = styled.div<TCaseContainerProps>`
  display: flex;
  justify-content: center;
  width: ${({ $isWide }) => ($isWide ? '1200px' : '840px')};
  flex-direction: column;
  margin: auto;
  gap: ${theme.spacings.s24};
  padding: ${({ $isWide }) => ($isWide ? `0 0 ${theme.spacings.s40} 0` : `${theme.spacings.s40} 0`)};

  @media (max-width: 1200px) and (min-width: 901px) {
    width: 840px;
    padding: ${theme.spacings.s24} 0;
  }

  @media (max-width: 900px) {
    width: 500px;
    padding: ${theme.spacings.s24} 0;
  }

  @media (max-width: 500px) {
    width: 343px;
    padding: ${theme.spacings.s24} 0;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Button = styled.div`
  width: ${theme.spacings.s48};
  height: ${theme.spacings.s48};
  border-radius: ${theme.spacings.s32};
  border: 1px solid ${theme.colors.lightPurple};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const MenuContainer = styled.div`
  ol {
    gap: ${theme.spacings.s8};

    a {
      font-family: 'Montserrat';
      font-weight: 400;
      font-size: 14px;
      text-decoration: underline;
      text-decoration-style: solid;

      &:hover {
        background-color: transparent;
        color: ${theme.colors.secondaryText};
      }
    }

    span {
      font-family: 'Montserrat';
      font-weight: 500;
      font-size: 14px;
      color: ${theme.colors.blue};
    }
  }
`;
